import {
  Grid,
  IconButton,
  Tab,
  Tabs,
  Button,
  AppBar,
  Paper,
} from '@mui/material'
import dayjs from 'dayjs'
import { isArray } from 'lodash'
import { useCallback, useContext, useEffect, useState } from 'react'
import { BiArrowBack } from 'react-icons/bi'
import { FaFileMedicalAlt, FaFileSignature } from 'react-icons/fa'
import { IoReceiptOutline } from 'react-icons/io5'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import { HeaderDay } from './components/HeaderDay'
import { ItemAtendimento } from './components/ItemAtendimento'
import { Receituario } from './components/Receituario'
import { RegistroAtendimento } from './components/RegistroAtendimento'
import { Timiline } from './components/Timiline'
import { Atestado } from './components/Atestado'
import { FaPersonCircleQuestion } from 'react-icons/fa6'
import { TbChartAreaLine } from 'react-icons/tb'
import { ListaQuestionario } from './components/Questionario'
import { Exames } from './components/Exames'
import { CurvaCrescimento } from './components/CurvaCrescimento'

const AtendimentoMedico = () => {
  const { agenda } = useContext(GlobalContext)

  const [tabSelected, setTabSelected] = useState('histClinico')
  const [atendimentos, setAtendimentos] = useState([])
  const [atendimentosFinalizados, setAtendimentosFinalizados] = useState([])
  const [tela, setTela] = useState('lista')
  const [idPaciente] = useState(null)
  const [cpf] = useState('')
  const [nome] = useState('')
  const [atendimentoSelecionado, setAtendimentoSelecionado] = useState({
    historicoClinico: [],
    dadosAtendimento: null,
  })

  const [selectedDate, setSelectedDate] = useState(dayjs())

  const getAtendimentos = useCallback(() => {
    const formattedDate = dayjs(selectedDate).format('DD-MM-YYYY')
    metodoPrograma('listaAtendimentos', {
      idAgenda: agenda?.[0],
      data: formattedDate,
      tpEstado: '3',
      idPaciente,
    }).then((response) => {
      if (response.status) {
        setAtendimentos(response.lista)
      }
    })

    metodoPrograma('listaAtendimentos', {
      idAgenda: agenda?.[0],
      data: formattedDate,
      tpEstado: '5',
      idPaciente,
    }).then((response) => {
      if (response.status) {
        setAtendimentosFinalizados(response.lista)
      }
    })
  }, [agenda, idPaciente, selectedDate])

  useEffect(() => {
    if (tela !== 'lista' || !agenda) return

    let atualizacaoPendente

    const atualizaAtendimentosAoReceberWebSocket = (event) => {
      let mensagem = event.detail

      if (typeof mensagem === 'string') {
        try {
          mensagem = JSON.parse(mensagem)
        } catch {
          return
        }
      }

      if (mensagem?.tipo !== 'AGENDAMENTO_MEDICO_ALTERADO') return
      if (String(mensagem.idAgenda) !== String(agenda[0])) return

      const dataVisualizada = dayjs(selectedDate).format('YYYY-MM-DD')
      const dataAlterada = String(mensagem.data).slice(0, 10)

      if (dataAlterada !== dataVisualizada) return

      clearTimeout(atualizacaoPendente)
      atualizacaoPendente = setTimeout(getAtendimentos, 250)
    }

    window.addEventListener(
      'frameworkfl:websocket-message',
      atualizaAtendimentosAoReceberWebSocket,
    )

    return () => {
      clearTimeout(atualizacaoPendente)
      window.removeEventListener(
        'frameworkfl:websocket-message',
        atualizaAtendimentosAoReceberWebSocket,
      )
    }
  }, [agenda, getAtendimentos, selectedDate, tela])

  const listaHistoricoPaciente = (atendimento, isViewHistoryAndSchedule) => {
    let idPaciente
    const atendimentoIsArray = isArray(atendimento)
    let newAtendimento
    if (atendimentoIsArray) {
      idPaciente = atendimento[7].idPaciente
    } else {
      idPaciente = atendimento
      newAtendimento = [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        { idPaciente, nmPaciente: nome, cdCpf: cpf },
      ]
    }
    metodoPrograma('listaHistoricoPaciente', {
      idPaciente,
      idAgenda: agenda?.[0],
    }).then((response) => {
      if (response.status) {
        setAtendimentoSelecionado({
          historicoClinico: response.lista,
          dadosAtendimento: atendimentoIsArray ? atendimento : newAtendimento,
        })
        if (
          isViewHistoryAndSchedule &&
          atendimento?.[5]?.tpEstado !== '5' &&
          atendimento?.[5]?.tpEstado !== '6'
        ) {
          setTela('atendimento-historico')
        } else {
          setTela('historico')
        }
      }
    })
  }

  useEffect(() => {
    if (!agenda) return
    if (tela === 'lista') {
      getAtendimentos()

      const intervalId = setInterval(() => {
        getAtendimentos()
      }, 30 * 1000) // meio minuto em milissegundos

      return () => clearInterval(intervalId)
    }
  }, [tela, getAtendimentos, agenda])

  console.log('agenda', agenda)

  return (
    <Programa
      codigo="CtrlAtendimentoMedico"
      ferramentas={
        tela !== 'lista' && (
          <IconButton onClick={() => setTela('lista')}>
            <BiArrowBack />
          </IconButton>
        )
      }
    >
      {tela === 'lista' && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <HeaderDay
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          >
            {idPaciente && (
              <Button
                onClick={() => listaHistoricoPaciente(idPaciente, false)}
                variant="outlined"
              >
                Histórico
              </Button>
            )}
            {idPaciente && (
              <Button
                variant="outlined"
                onClick={() => listaHistoricoPaciente(idPaciente, true)}
              >
                Atender
              </Button>
            )}
          </Grid>
          <Grid item xs={12}>
            <h2>Pacientes em Espera</h2>

            {atendimentos.length === 0 ? (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: '14px 16px',
                  marginTop: 8,
                  borderRadius: 10,
                  backgroundColor: '#f6f8fa',
                  border: '1px solid #e5e7eb',
                  color: '#6b7280',
                }}
              >
                <div
                  style={{
                    fontSize: 20,
                    lineHeight: 1,
                  }}
                >
                  🩺
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: 14, fontWeight: 500 }}>
                    Nenhum paciente em espera
                  </span>

                  <span style={{ fontSize: 12, color: '#9ca3af' }}>
                    Todos os pacientes foram atendidos ou ainda não foram
                    encaminhados.
                  </span>
                </div>
              </div>
            ) : (
              atendimentos.map((atendimento) => (
                <ItemAtendimento
                  key={atendimento[0]}
                  {...{ listaHistoricoPaciente, atendimento, setTela }}
                />
              ))
            )}
          </Grid>
          {atendimentosFinalizados.length > 0 && (
            <Grid item xs={12} style={{ marginTop: '30px' }}>
              <h2>Atendidos</h2>
              {atendimentosFinalizados.map((atendimento) => (
                <ItemAtendimento
                  key={atendimento.id}
                  {...{ listaHistoricoPaciente, atendimento, setTela }}
                />
              ))}
            </Grid>
          )}
        </Grid>
      )}
      {tela === 'atendimento-historico' && (
        <RegistroAtendimento
          atendimentoSelecionado={atendimentoSelecionado}
          getAtendimentos={getAtendimentos}
          setAtendimentoSelecionado={setAtendimentoSelecionado}
          setTela={setTela}
        />
      )}
      {(tela === 'historico' || tela === 'atendimento-historico') && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            {/* 
              21	"Avaliação Médica"
              22	"Avaliação Nutricional"
              23	"Avaliação Psicológica"
              50	"Avaliação Biológica"
              */}
            <AppBar
              position="static"
              variant="outlined"
              color="primary"
              sx={{
                borderRadius: 3, // 16px
                overflow: 'hidden',
              }}
            >
              <Tabs
                value={tabSelected}
                onChange={(e, value) => setTabSelected(value)}
                textColor="inherit"
                variant="fullWidth"
                TabIndicatorProps={{ sx: { backgroundColor: '#fff' } }}
                sx={{
                  '& .Mui-selected': { color: '#fff !important' },
                }}
              >
                {agenda[21] === 'S' && [
                  <Tab
                    key={'form'}
                    icon={<FaFileMedicalAlt />}
                    label="Histórico Clínico"
                    value="histClinico"
                  />,
                ]}
                {agenda[22] === 'S' && [
                  <Tab
                    key={'form'}
                    icon={<FaPersonCircleQuestion />}
                    label="Questionário"
                    value="questionario"
                  />,
                ]}
                {agenda[31] === 'S' && [
                  <Tab
                    key="curva"
                    icon={<TbChartAreaLine />}
                    label="Curva de Crescimento"
                    value="curvaCrescimento"
                  />,
                ]}
                {agenda[23] === 'S' && [
                  <Tab
                    key="rec"
                    icon={<IoReceiptOutline />}
                    label="Receituário"
                    value="receituario"
                  />,
                ]}
                {agenda[24] === 'S' && [
                  <Tab
                    key="atest"
                    icon={<FaFileMedicalAlt />}
                    label="Atestado"
                    value="atestado"
                  />,
                ]}
                {agenda[27] === 'S' && [
                  <Tab
                    key="exames"
                    icon={<FaFileSignature />}
                    label="Exames"
                    value="exames"
                  />,
                ]}
              </Tabs>
            </AppBar>
          </Grid>
          <Grid item xs={12}>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                mb: 3,
                borderRadius: 2,
              }}
            >
              {tabSelected === 'histClinico' && (
                <Grid item xs={12}>
                  <div>
                    {atendimentoSelecionado.historicoClinico?.length > 0 ? (
                      atendimentoSelecionado.historicoClinico.map(
                        (item, index) => <Timiline key={index} item={item} />,
                      )
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 12,
                          padding: '14px 16px',
                          marginTop: 8,
                          borderRadius: 10,
                          backgroundColor: '#f6f8fa',
                          border: '1px solid #e5e7eb',
                          color: '#6b7280',
                        }}
                      >
                        <div
                          style={{
                            fontSize: 20,
                            lineHeight: 1,
                          }}
                        >
                          🩺
                        </div>

                        <div
                          style={{ display: 'flex', flexDirection: 'column' }}
                        >
                          <span style={{ fontSize: 14, fontWeight: 500 }}>
                            Nenhum registro no histórico clínico
                          </span>

                          <span style={{ fontSize: 12, color: '#9ca3af' }}>
                            Ainda não existem registros clínicos cadastrados
                            para este paciente.
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </Grid>
              )}
              {tabSelected === 'exames' && (
                <Exames atendimentoSelecionado={atendimentoSelecionado} />
              )}
              {tabSelected === 'curvaCrescimento' && (
                <CurvaCrescimento
                  atendimentoSelecionado={atendimentoSelecionado}
                />
              )}
              {tabSelected === 'receituario' && (
                <Receituario atendimentoSelecionado={atendimentoSelecionado} />
              )}
              {tabSelected === 'atestado' && (
                <Atestado atendimentoSelecionado={atendimentoSelecionado} />
              )}
              {tabSelected === 'questionario' && (
                <ListaQuestionario
                  atendimentoSelecionado={atendimentoSelecionado}
                />
              )}
            </Paper>
          </Grid>
        </Grid>
      )}
    </Programa>
  )
}

export default AtendimentoMedico
